export default __webpack_public_path__ + "static/media/dog_result.ba5cc275.png";